/**
 * devWarn — one-shot dev-only console warnings for the hub kit.
 *
 * The `false` default is load-bearing. The original returned `true` when
 * `globalThis.process` was undefined — which is the normal case in a shipped
 * browser bundle — so every kit warning could fire at real end users. Silence is
 * the safe default; the app opts in (see the `__TPL_DEV__` line at the top of
 * `frontend/src/index.tsx`).
 *
 * CRA's webpack replaces the literal text `process.env.NODE_ENV` at build time,
 * but NOT a dynamic property read like `g.process?.env`, so the fallback below
 * genuinely evaluates at runtime and genuinely finds nothing in the browser.
 * That is why the explicit opt-in exists rather than being relied upon.
 */
const warned = new Set<string>();

const devMode = (): boolean => {
  try {
    const g = globalThis as {
      process?: { env?: Record<string, string | undefined> };
      __TPL_DEV__?: boolean;
    };
    if (typeof g.__TPL_DEV__ === 'boolean') return g.__TPL_DEV__;
    const env = g.process?.env;
    return env ? env.NODE_ENV !== 'production' : false;
  } catch {
    return false;
  }
};

/** One warning per unique key per session — a surface re-renders a lot. */
export function devWarn(key: string, message: string): void {
  if (!devMode() || warned.has(key)) return;
  warned.add(key);
  // eslint-disable-next-line no-console
  console.warn(`[HubTableSurface] ${message}`);
}

export default devWarn;
